export const isDefined = (value: any): boolean => {
    return !!value || value === 0 || value === '';
};

export const isUndefined = (value?: string | number | null | Date | boolean): boolean => !value && value === undefined;

export const isUndefinedNull = (value?: string | number | null | Date): boolean =>
    !value && (value === null || value === undefined);
